import styled from 'styled-components';
import { SCP } from 'ia-react-core/~/interfaces/SCP';

// https://kovart.github.io/dashed-border-generator/
const dashedBorder = (color: string) => `
  url("
    data:image/svg+xml,%3csvg
    width='100%25'
    height='100%25'
    xmlns='http://www.w3.org/2000/svg'%3e%3crect 
    width='100%25'
    height='100%25'
    fill='none'
    stroke='${encodeURIComponent(color)}'
    stroke-width='2'
    stroke-dasharray='3%2c 5'
    stroke-dashoffset='0'
    stroke-linecap='square'/%3e%3c/svg%3e
  ")
`;

export const StyledSection = styled.section<SCP<'section'>>`
  position: relative;
  border-radius: 4px;
  background-image: ${({ theme }) => dashedBorder(theme.colors.primary)};
`;

export const StyledHeader = styled.header`
  position: absolute;
  top: 0;
  right: 2px;
  z-index: 1;
`;

export const StyledContent = styled.div`
  font-size: 14px;
`;
